import { useResource } from "./useResource";

// GET /api/v1/search — the command palette's server-backed results (actions +
// full-text repos/tasks). A task ref carries `repo_public_id` and `display_id`
// because that pair is what its URL is keyed on; `public_id` identifies the
// result but does not address the page (`api.md` §Task).
export type SearchResult = {
  readonly hint?: string;
  readonly label: string;
  readonly ref?: {
    /** `T-NNN` for a task; null for a repo, which has no second id. */
    readonly display_id: string | null;
    readonly kind: string;
    readonly public_id: string;
    readonly repo_public_id: string | null;
  };
  readonly sublabel?: string | null;
  readonly type: string;
};

export type UseSearch = {
  readonly loading: boolean;
  readonly results: ReadonlyArray<SearchResult>;
};

// Pass the (debounced) query; an empty query returns the default weighted set.
export const useSearch = (query: string): UseSearch => {
  const { data, loading } = useResource<{
    results: ReadonlyArray<SearchResult>;
  }>("/search", {
    limit: 20,
    q: query,
  });
  return { loading, results: data?.results ?? [] };
};
